/* eslint-disable */ 
import React, { useState ,useEffect} from "react";
import { Logo } from "../_components/Imagepath";
import axios from "axios";
import ProfileBiodata from "../layouts/ProfileBiodata";
import BookEmployerBiodataShared from '../employers/BookEmployerBiodataShared';
import { useTranslation } from "react-i18next";
import Lang from '../common/Lang';

// Add some inline styles for simple appearance
const styles = {
  hoverShadow: {
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },
  logoContainer: {
    background: '#f8f9fa',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '30px',
    border: '1px solid #e9ecef'
  },
  welcomeCard: {
    background: '#f8f9fa',
    color: '#495057',
    border: '1px solid #dee2e6'
  }
};
const EmployerBiodataShared = (props) => {
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [selectedBiodata, setSelectedBiodata] = useState(null);
  const [loading, setLoading] = useState(true);
  const {t} = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  const fetchData = async () => {
    setError(null);
    setLoading(true);

    try {
      const typeurl="/employer-biodata-shared/";
      const response = await axios.get(process.env.REACT_APP_BASE_URL+typeurl, {
        params: { token: token }
      });

      setData(response.data);
    } catch (error) {
      const responseCode = error.response?.status || "Unknown";
      setError(`${t("Failed to load biodata")}: ${responseCode}`);
    } finally {
      setLoading(false);
    }
  };
      
  useEffect(() => {
    fetchData();
  }, []);

  const itemsPerPage = 10; // Number of items per page
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get current page data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = data.slice(startIndex, startIndex + itemsPerPage);

  const handleBiodataClick = (biodata) => {
    setSelectedBiodata(biodata);
  }

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            {/* <div className="text-center mb-4" style={styles.logoContainer}>
              <h1 className="mb-2 text-dark">{t("Biodata Selection")}</h1>
              <p className="account-subtitle">{t("Professional biodata matching service")}</p>
            </div> */}
            
            {/* Error State */}
            {error && (
              <div className="alert alert-light border border-danger text-center">
                <i className="fas fa-exclamation-circle text-danger mb-2"></i>
                <h6 className="text-danger">{t("Error")}</h6>
                <p className="mb-0 text-muted small">{error}</p>
              </div>
            )}
            
            {/* Loading State */}
            {loading && !error && (
              <div className="text-center py-5">
                <i className="fa-solid fa-spinner fa-spin fa-2x text-secondary mb-3"></i>
                <h5 className="text-muted">{t("Loading biodata...")}</h5>
                <p className="text-muted">{t("Please wait while we fetch the information")}</p>
              </div>
            )}
            
            {/* Content */}
            {!loading && !error && (
              <div className="card bg-white shadow-sm border-0">
                <div className="card-body p-4">
                    {/* Agency Information */}
                    <div className="mb-4">
                      {currentData.length > 0 && currentData[0].agency ? 
                        currentData[0].agency?.imgprofile ?
                        (
                          <div className="text-center mb-3">
                            <img
                              className="img-fluid rounded shadow-sm"
                              src={currentData[0].agency.imgprofile}
                              alt="Agency Logo"
                              style={{ maxWidth: '100px', height: 'auto' }}
                            />
                          </div>
                        ) : (
                          <div className="text-center mb-3">
                            <h6 className="text-secondary">{currentData[0].agency.name}</h6>
                          </div>
                        ) 
                      : (
                        <div className="text-center mb-3">
                          <p className="text-muted small">{t("Loading Agency Information...")}</p>
                        </div>
                      )}
                    </div>

                    {/* Welcome Message */}
                    <div className="mb-4">
                      <div className="alert alert-light" style={styles.welcomeCard}>
                        <h5 className="mb-2 text-dark">
                          {t("Hi")} {currentData.length > 0 && currentData[0].employer ? `${t(currentData[0].employer.title)} ${currentData[0].employer.name}` : "..." },
                        </h5>
                        <p className="mb-2">{t("This is our selection of biodata for your requirements.")}</p>
                        <p className="mb-0">
                          {t("Please contact")} {currentData.length > 0 && currentData[0].agency_user ? `${currentData[0].agency_user.name} at ${currentData[0].agency_user.phone}` : "..." } {t("if you have any questions")}
                        </p>
                      </div>
                    </div>
                    
                    {/* Biodata Grid */}
                    {currentData.length > 0 ? (
                      <div className="row">
                        {currentData.map((item, index) => {
                          const biodata = item.biodata_agency_model || item.biodata_supplier_model;
                      
                          if (!biodata) return null;
                      
                          return (
                            <div key={index} className="col-12 col-sm-6 col-lg-4 mb-4">
                              <div 
                                className="card h-100 border shadow-sm" 
                                style={styles.hoverShadow}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                              >
                                <ProfileBiodata 
                                  packageId={currentData[0].shared_biodata_package} 
                                  item={biodata} 
                                  type={'employer'} 
                                  onClick={() => handleBiodataClick(biodata)} 
                                  selectedBiodata={selectedBiodata} 
                                  setSelectedBiodata={setSelectedBiodata} 
                                  onRefresh={fetchData}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <div className="alert alert-light border">
                          <i className="fas fa-info-circle text-secondary mb-2"></i>
                          <h6 className="text-secondary">{t("No biodata available")}</h6>
                          <p className="mb-0 text-muted small">{t("Please contact the agency for more information")}</p>
                        </div>
                      </div>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <div className="mt-4">
                        <div className="d-flex justify-content-center align-items-center">
                          <button
                            className="btn btn-outline-secondary me-3"
                            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                          >
                            <i className="fas fa-chevron-left me-1"></i>
                            {t("Previous")}
                          </button>
                          
                          <span className="mx-3 px-3 py-1 bg-light text-dark rounded">
                            {t("Page")} {currentPage} {t("of")} {totalPages}
                          </span>
                          
                          <button
                            className="btn btn-outline-secondary ms-3"
                            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                          >
                            {t("Next")}
                            <i className="fas fa-chevron-right ms-1"></i>
                          </button>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}
            
            {/* Footnote */}
            <div className="text-center mt-4 mb-2">
              <small className="text-muted">
                {t("Powered by")} <img src={Logo} alt="Kflow" style={{ height: '16px', verticalAlign: 'middle' }} className="mx-1" />
              </small>
            </div>
            
            <div className="lang-menu">
              <ul className="nav nav-tabs user-menu">
                <div className="lang-item">
                  <Lang />
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <BookEmployerBiodataShared biodata={selectedBiodata} fetchData={fetchData}/>
    </>
  );
};

export default EmployerBiodataShared;